export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row gy-4 align-items-start">
          <div className="col-lg-5">
            <div className="d-flex align-items-center gap-2 mb-3">
              <span className="brand-mark">VR</span>
              <h5 className="mb-0 fw-bold">VRGlobal Soft</h5>
            </div>
            <p className="text-soft mb-0">
              Professional software development, ERP applications, SEO, domain
              registration, servers, hosting and social media ads for growing
              businesses.
            </p>
          </div>
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-title">Services</h6>
            <p className="footer-link">ERP Application</p>
            <p className="footer-link">SEO & Digital Marketing</p>
            <p className="footer-link">Servers & Hosting</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <h6 className="footer-title">Contact</h6>
            <p className="footer-link">
              <i className="bi bi-envelope me-2"></i> info@vrglobalsoft.com
            </p>
            <p className="footer-link">
              <i className="bi bi-globe me-2"></i> vrglobalsoft.com
            </p>
            <p className="footer-link">
              <i className="bi bi-geo-alt me-2"></i> India
            </p>
          </div>
        </div>
        <hr className="border-light opacity-10 my-4" />
        <div className="text-center text-soft small">
          © {new Date().getFullYear()} VRGlobal Soft. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
